webpackJsonp([1],{

/***/ "+jUW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/NOU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12 col-lg-12",attrs:{"id":"timer"}},[_c('vue-slider',_vm._b({ref:"slider",on:{"callback":_vm.updateSlider,"drag-start":_vm.dragStart,"drag-end":_vm.dragEnd},model:{value:(_vm.slider_data.value),callback:function ($$v) {_vm.slider_data.value=$$v},expression:"slider_data.value"}},'vue-slider',_vm.slider_data,false)),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-12 "},[_c('button',{staticClass:"btn",attrs:{"type":"button","id":"start"},on:{"click":function($event){_vm.animateGraph()}}},[_vm._v("Start"),_c('icon',{attrs:{"name":"play"}})],1),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button","id":"stop"},on:{"click":function($event){_vm.stopAnimation()}}},[_vm._v("Stop"),_c('icon',{attrs:{"name":"stop"}})],1),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button","id":"pause"},on:{"click":function($event){_vm.pauseAnimation()}}},[_vm._v("Pause"),_c('icon',{attrs:{"name":"pause"}})],1),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button","id":"faster"},on:{"click":function($event){_vm.fasterAnimation()}}},[_vm._v("Faster"),_c('icon',{attrs:{"name":"step-forward"}})],1),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button","id":"slower"},on:{"click":function($event){_vm.slowerAnimation()}}},[_vm._v("Slower"),_c('icon',{attrs:{"name":"step-backward"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/o7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0GND":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0NQM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"storms"}},[_c('h2',{staticClass:"text-center"},[_vm._v("Notable Storms")]),_vm._v(" "),_c('p',{staticClass:"col-sm-10 offset-sm-1 col-lg-10 offset-lg-1"},[_vm._v("\n    Mercifully, storms have gotten less deadly over time. This is due largely to greatly improved forecasting,\n    which often allows time to evacuate inland, away from the worst of a storm. Particularly before the satellite\n    era people would often have no idea that a storm was even approaching until it was right on top of them.\n  ")]),_vm._v(" "),_c('p',{staticClass:"col-sm-10 offset-sm-1 col-lg-10 offset-lg-1"},[_vm._v("\n    Highlighted below are the storm paths of some of the worlds most powerful and expensive storms. Notice that\n    while Sandy was a very expensive storm it wasn't particularly powerful as hurricanes go, highlighting how\n    densely populated regions are quite vulnerable to even relatively modest storms.\n    Note, the great Atlantic storms of 2017 are not included as data is not yet available.\n  ")]),_vm._v(" "),_c('circle-legend',{attrs:{"dataValues":_vm.hurricanes,"field":_vm.selector}}),_vm._v(" "),_vm._l((_vm.names),function(name){return [_c('div',{staticClass:"col-xs-12 col-sm-6 col-lg-4",attrs:{"id":"map-divs"}},[_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(name.name))]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("\n        Date: "+_vm._s(name.date)),_c('br'),_vm._v("\n        Wind: "+_vm._s(name.mph)+"/"+_vm._s(name.km)+" mph/km/h"),_c('br'),_vm._v("\n        "+_vm._s(name.cost))]),_vm._v(" "),_c('canvas',{attrs:{"id":name.name,"height":_vm.height,"width":_vm.width}})])]}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row col-sm-12 col-lg-12 "},[_c('footer',[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_c('a',{attrs:{"href":"../index.php"}},[_vm._v("Other Visualizations")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"../western_water"}},[_vm._v("Western Water")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"mailto:farrelldlfarrell@gmail.com"}},[_vm._v("Email")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://twitter.com/farrelldlfarrel"}},[_vm._v("Twitter")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" row col-sm-12 col-lg-12"},[_c('div',{staticClass:"col-offset-md-1 subfooter"},[_c('h3',{staticClass:"text-center"},[_vm._v("Data Sources")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled text-center"},[_c('li',[_c('a',{attrs:{"href":"https://www.ncdc.noaa.gov/ibtracs/index.php?name=ibtracs-data"}},[_vm._v("Storm Paths")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://en.wikipedia.org/wiki/List_of_the_most_intense_tropical_cyclones"}},[_vm._v("Strongest Storms")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://en.wikipedia.org/wiki/List_of_costliest_Atlantic_hurricanes"}},[_vm._v("Most Expensive Storms")])])]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("For those really into map projections, all the maps above use the\n        "),_c('a',{attrs:{"href":"https://en.wikipedia.org/wiki/Equirectangular_projection"}},[_vm._v("equirectangular projection")]),_vm._v(".")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "17cw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleLegend_vue__ = __webpack_require__("GwGZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ddb5868_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CircleLegend_vue__ = __webpack_require__("wXSp");
function injectStyle (ssrContext) {
  __webpack_require__("+jUW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ddb5868"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleLegend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ddb5868_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CircleLegend_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3GDu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__("fGNU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735bf95d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__("ldtw");
function injectStyle (ssrContext) {
  __webpack_require__("ZudC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-735bf95d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735bf95d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Biga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.clazz,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path){return _c('path',_vm._b({},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon){return _c('polygon',_vm._b({},'polygon',polygon,false))}):_vm._e(),_vm._v("\b\n    "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.icon.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c42312ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("Biga");
function injectStyle (ssrContext) {
  __webpack_require__("Ga5j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c42312ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FNkW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Scroller',

  computed: {
    selectedHurricanes: function selectedHurricanes() {
      var hurricanes = __WEBPACK_IMPORTED_MODULE_1_lodash__["groupBy"](this.$store.getters.getSelectedHurricanes, 'name');
      var names = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(hurricanes);

      return names.map(function (d) {
        return __WEBPACK_IMPORTED_MODULE_1_lodash__["last"](hurricanes[d], 'name');
      });
    }
  }
});

/***/ }),

/***/ "Ga5j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GaJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"scrolling"}},[_c('ul',{attrs:{"id":"scroller-list"}},_vm._l((_vm.selectedHurricanes),function(h){return _c('li',[_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(h.name))]),_vm._v(" "),_c('p',[_vm._v("\n        "+_vm._s(h.date)),_c('br'),_vm._v("\n        Wind: "+_vm._s(h.mph)+" mph"),_c('br'),_vm._v("\n        Latitude: "+_vm._s(h.display_lat)),_c('br'),_vm._v("\n        Longitude: "+_vm._s(h.display_lng)),_c('br')])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gp+1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_play__ = __webpack_require__("adK7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_stop__ = __webpack_require__("15zA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_pause__ = __webpack_require__("g29p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_step_forward__ = __webpack_require__("IqG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_step_backward__ = __webpack_require__("KRVI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Timer',

  data: function data() {
    return {
      slider_values_length: 0,
      current_slider_index: 0,
      animated: false,
      animating: {},
      animationInterval: 100,
      slider_data: {
        value: '1995-01-01 00:00',
        width: '80%',
        clickable: false,
        speed: .5,
        formatter: function formatter(value) {
          var formatting = __WEBPACK_IMPORTED_MODULE_0_d3__["d" /* timeFormat */]('%b %d %I:%M %p, %Y');
          var create_date = __WEBPACK_IMPORTED_MODULE_0_d3__["e" /* timeParse */]("%Y-%m-%d %H:%M");
          return formatting(create_date(value));
        },
        style: {
          marginLeft: '10%',
          marginBottom: '1%'
        },
        data: []
      }
    };
  },


  props: {
    dateValues: Array
  },

  watch: {
    dateValues: function dateValues(val) {
      this.slider_data.data = val;
      this.slider_values_length = this.slider_data.data.length;
    }
  },

  components: {
    vueSlider: __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */]
  },

  methods: {
    filteredData: function filteredData(test_value) {
      var parse_date = __WEBPACK_IMPORTED_MODULE_0_d3__["e" /* timeParse */]('%Y-%m-%d %H:%M');
      var date_to_milli = parse_date(test_value).getTime();
      var one_week = 60 * 60 * 144 * 1000;

      return this.$store.getters.getHurricanes.filter(function (d) {
        return d.full_date <= date_to_milli && d.full_date >= date_to_milli - one_week;
      });
    },
    updateSlider: function updateSlider(val) {
      this.$store.dispatch('setSelectedHurricanes', this.filteredData(val));
    },
    animateGraph: function animateGraph() {
      var _this = this;

      var current_index = this.getIndex('slider');
      this.animated = true;

      var timing = __WEBPACK_IMPORTED_MODULE_0_d3__["n" /* interval */](function (elapsed) {
        if (_this.current_slider_index > _this.slider_values_length) {
          timing.stop();
        }
        _this.current_slider_index = current_index += 1;
        _this.setIndex('slider', _this.current_slider_index);
      }, this.animationInterval);

      this.animating = timing;
    },
    stopAnimation: function stopAnimation() {
      if (this.animated) {
        this.animating.stop();
        this.setIndex('slider', 0);
      }
    },
    pauseAnimation: function pauseAnimation() {
      if (this.animated) {
        this.animating.stop();
      }
    },
    fasterAnimation: function fasterAnimation() {
      var interval = this.animationInterval;
      var speed = this.slider_data.speed;
      this.animationInterval = interval <= 100 ? interval -= 25 : interval;
      this.slider_data.speed = speed <= .9 ? speed += .2 : speed;
    },
    slowerAnimation: function slowerAnimation() {
      var interval = this.animationInterval;
      var speed = this.slider_data.speed;
      this.animationInterval = interval > 50 ? interval += 25 : interval;
      this.slider_data.speed = speed > .5 ? speed -= .2 : speed;
    },
    setIndex: function setIndex(name, num) {
      var slider = this.$refs[name];
      slider.setIndex(num);
    },
    getIndex: function getIndex(name) {
      var slider = this.$refs[name];
      return slider.getIndex();
    },
    dragStart: function dragStart() {
      this.pauseAnimation();
    },
    dragEnd: function dragEnd() {
      this.animateGraph();
    }
  }
});

/***/ }),

/***/ "GwGZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_svg_legend__ = __webpack_require__("KZx+");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CircleLegend',

  data: function data() {
    return {
      width: '',
      height: '',
      centerClass: false
    };
  },


  props: {
    dataValues: Array,
    field: String
  },

  computed: {
    offSet: function offSet() {
      var orientation = this.legendOrientation().orientation;

      if (orientation === 'horizontal' && this.field === 'canvas') {
        return '-65px';
      } else if (orientation === 'horizontal') {
        return '-45px';
      }

      return 0;
    }
  },

  watch: {
    dataValues: function dataValues(val) {
      this.dataValues = val;
      this.draw();
    }
  },

  methods: {
    circleSizing: function circleSizing() {
      var sizing = void 0;

      if (this.field === 'canvas') {
        sizing = [.5, 6];
      } else {
        sizing = [1, 10];
      }

      return sizing;
    },
    legendOrientation: function legendOrientation() {
      var screen_width = window.innerWidth;
      var orientation = void 0;

      if (screen_width < 1000) {
        orientation = 'vertical';
        this.height = 250;
        this.width = window.innerWidth;
      } else {
        orientation = 'horizontal';
        this.width = 350;
        this.height = 70;
      }

      return { orientation: orientation };
    },
    chartType: function chartType() {
      var format = void 0,
          spacing = void 0;

      format = '.01f';

      if (window.innerWidth < 1000) {
        spacing = 25;
      } else {
        spacing = 50;
      }

      return { format: format, spacing: spacing };
    },
    legendCircle: function legendCircle() {
      var legend_scales = __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* scaleSqrt */]().domain(__WEBPACK_IMPORTED_MODULE_0_d3__["b" /* extent */](this.dataValues, function (d) {
        return +d.mph;
      })).range(this.circleSizing());
      var configs = this.legendOrientation();
      var chart_format = this.chartType();

      return __WEBPACK_IMPORTED_MODULE_1_d3_svg_legend__["a" /* default */].legendSize().scale(legend_scales).shape('circle').shapePadding(chart_format.spacing).labelOffset(20).labelFormat(__WEBPACK_IMPORTED_MODULE_0_d3__["c" /* format */](chart_format.format)).orient(configs.orientation);
    },
    draw: function draw() {
      var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["f" /* select */]('#' + this.field);
      var legend_scale = this.legendCircle();

      if (this.whichType !== 'map') {
        setTimeout(function () {
          svg.call(legend_scale);
        }, 500);
      } else {
        svg.call(legend_scale);
      }
    }
  }
});

/***/ }),

/***/ "Gwtn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IckW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    currentDate: '',
    hurricanes: [],
    selectedHurricanes: []
  },

  getters: {
    getCurrentDate: function getCurrentDate(state) {
      return state.currentDate;
    },
    getHurricanes: function getHurricanes(state) {
      return state.hurricanes;
    },
    getSelectedHurricanes: function getSelectedHurricanes(state) {
      return state.selectedHurricanes;
    }
  },

  mutations: {
    setCurrentDate: function setCurrentDate(state, currentDate) {
      state.currentDate = currentDate;
    },
    setHurricanes: function setHurricanes(state, hurricanes) {
      state.hurricanes = hurricanes;
    },
    setSelectedHurricanes: function setSelectedHurricanes(state, selectedHurricanes) {
      state.selectedHurricanes = selectedHurricanes;
    }
  },

  actions: {
    setCurrentDate: function setCurrentDate(_ref, currentDate) {
      var commit = _ref.commit;

      commit('setCurrentDate', currentDate);
    },
    setHurricanes: function setHurricanes(_ref2, hurricanes) {
      var commit = _ref2.commit;

      commit('setHurricanes', hurricanes);
    },
    setSelectedHurricanes: function setSelectedHurricanes(_ref3, selectedHurricanes) {
      var commit = _ref3.commit;

      commit('setSelectedHurricanes', selectedHurricanes);
    }
  }
}));

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KDYt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanvasMap_vue__ = __webpack_require__("zVxl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60f2f625_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CanvasMap_vue__ = __webpack_require__("0NQM");
function injectStyle (ssrContext) {
  __webpack_require__("Gwtn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60f2f625"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanvasMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60f2f625_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_CanvasMap_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12535bd7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("/o7+");
function injectStyle (ssrContext) {
  __webpack_require__("xmL5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12535bd7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__("sCSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_styles_css__ = __webpack_require__("IckW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_styles_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Map__ = __webpack_require__("3GDu");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: '/hurricanes/',

  routes: [{
    path: '/',
    name: 'Map',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Map__["a" /* default */]
  }]
}));

/***/ }),

/***/ "ZqlF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timer_vue__ = __webpack_require__("Gp+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17fb0886_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Timer_vue__ = __webpack_require__("/NOU");
function injectStyle (ssrContext) {
  __webpack_require__("gTO5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17fb0886"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17fb0886_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Timer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZudC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),

/***/ "fGNU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Timer__ = __webpack_require__("ZqlF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Scroller__ = __webpack_require__("zfDY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CanvasMap__ = __webpack_require__("KDYt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CircleLegend__ = __webpack_require__("17cw");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Map',

  data: function data() {
    return {
      loading: true,
      selector: 'main',
      width: Math.round(window.innerWidth * .8),
      base_height: window.innerHeight,
      height: 650,
      map: {},
      scale: {},
      projection: {},
      dates: [],
      hurricanes: []
    };
  },


  components: {
    Timer: __WEBPACK_IMPORTED_MODULE_2__Timer__["a" /* default */],
    Scroller: __WEBPACK_IMPORTED_MODULE_3__Scroller__["a" /* default */],
    CanvasMap: __WEBPACK_IMPORTED_MODULE_4__CanvasMap__["a" /* default */],
    CircleLegend: __WEBPACK_IMPORTED_MODULE_5__CircleLegend__["a" /* default */]
  },

  computed: {
    selectedHurricanes: function selectedHurricanes() {
      return this.$store.getters.getSelectedHurricanes;
    }
  },

  methods: {
    hurricaneNote: function hurricaneNote(d) {
      return '<h5 class="text-center">' + d.name + '</h5>\n      <p>\n      ' + d.date + '\n      Wind: ' + d.mph + ' mph<br/>\n      Latitude: ' + d.display_lat + '<br/>\n      Longitude: ' + d.display_lng + '\n      </p>';
    },
    mapScale: function mapScale(data) {
      return __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* scaleSqrt */]().domain(__WEBPACK_IMPORTED_MODULE_0_d3__["b" /* extent */](data, function (d) {
        return d.wind;
      })).range([1, 10]);
    },
    filteredData: function filteredData(test_value) {
      var parse_date = this.dateFormat();
      var date_to_milli = parse_date(test_value).getTime();
      var one_week = 60 * 60 * 168 * 1000;

      return this.$store.getters.getHurricanes.filter(function (d) {
        return d.full_date <= date_to_milli && d.full_date >= date_to_milli - one_week;
      });
    },
    formatValues: function formatValues(data) {
      var ktToMph = 1.1152;
      var ktToKm = 1.85;
      var windFormat = __WEBPACK_IMPORTED_MODULE_0_d3__["c" /* format */](".1f");
      var dateParse = this.dateFormat();
      var dateFormat = __WEBPACK_IMPORTED_MODULE_0_d3__["d" /* timeFormat */]('%b %d %I:%M %p, %Y');

      data.forEach(function (d) {
        d.mph = windFormat(d.wind * ktToMph);
        d.km = windFormat(d.wind * ktToKm);
        d.date = dateFormat(dateParse(d.time));
        d.name = __WEBPACK_IMPORTED_MODULE_1_lodash__["capitalize"](d.name.toLowerCase());
        d.display_lat = __WEBPACK_IMPORTED_MODULE_1_lodash__["round"](d.lat, 3);
        d.display_lng = __WEBPACK_IMPORTED_MODULE_1_lodash__["round"](d.lng, 3);
      });

      return data;
    },
    dateFormat: function dateFormat() {
      return __WEBPACK_IMPORTED_MODULE_0_d3__["e" /* timeParse */]('%Y-%m-%d %H:%M');
    },
    draw: function draw() {
      var parse_date = this.dateFormat();
      var vm = this;
      var svg = __WEBPACK_IMPORTED_MODULE_0_d3__["f" /* select */]('#map g');

      __WEBPACK_IMPORTED_MODULE_0_d3__["g" /* queue */]().defer(__WEBPACK_IMPORTED_MODULE_0_d3__["h" /* json */], 'static/data/map.geojson').defer(__WEBPACK_IMPORTED_MODULE_0_d3__["i" /* csv */], 'static/data/all_storms_short_1995.csv').await(function (error, map, data) {
        vm.map = map;

        data.forEach(function (d) {
          d.full_date = parse_date(d.time).getTime();
        });

        vm.hurricanes = vm.formatValues(data);
        vm.$store.dispatch('setHurricanes', vm.hurricanes);
        vm.dates = __WEBPACK_IMPORTED_MODULE_1_lodash__["map"](__WEBPACK_IMPORTED_MODULE_1_lodash__["uniqBy"](data, 'time'), 'time');

        var test_value = data[0].time;
        vm.$store.dispatch('setSelectedHurricanes', vm.filteredData(test_value));

        var offset = vm.width >= 1100 ? 2.1 : 2.5;
        vm.scale = vm.mapScale(data);

        var scale = 1,
            mapType = __WEBPACK_IMPORTED_MODULE_0_d3__["j" /* geoEquirectangular */](),
            projection = mapType.scale(scale).translate([0, 0]);

        var path = __WEBPACK_IMPORTED_MODULE_0_d3__["k" /* geoPath */]().projection(projection);
        var bounds = path.bounds(map);
        scale = .95 / Math.max((bounds[1][0] - bounds[0][0]) / vm.width, (bounds[1][1] - bounds[0][1]) / vm.height);
        var translation = [(vm.width - scale * (bounds[1][0] + bounds[0][0])) / 2, (vm.height - scale * (bounds[1][1] + bounds[0][1])) / offset];

        // update projection
        projection = mapType.scale(scale).translate(translation);

        path = path.projection(projection);
        vm.projection = projection;

        var zoom = __WEBPACK_IMPORTED_MODULE_0_d3__["l" /* zoom */]().scaleExtent([1, 5]).on('zoom', zoomed);
        svg.call(zoom);

        var maps = svg.selectAll('path').data(map.features);

        maps.enter().append('path').merge(maps).attr('vector-effect', 'non-scaling-stroke').attr('d', path);

        maps.exit().remove();

        function zoomed() {
          svg.attr("transform", __WEBPACK_IMPORTED_MODULE_0_d3__["m" /* event */].transform);
        }

        vm.loading = false;
      });
    }
  },

  mounted: function mounted() {
    this.draw();
  }
});

/***/ }),

/***/ "gTO5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ldtw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12 col-lg-12"},[(_vm.loading)?_c('div',{staticClass:"loader"},[_vm._v("Loading...")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",class:{'show': _vm.loading}},[_c('h1',{staticClass:"text-center"},[_vm._v("Storms of the World - Cyclones, Typhoons and Hurricanes")]),_vm._v(" "),_c('p',{staticClass:"col-sm-10 offset-sm-1 col-lg-10 offset-lg-1"},[_vm._v("\n      There are a surprising number of tropical disturbances every year. Most you rarely think about,\n      or have likely never even heard of, unless they're headed your way. Historically, storm data is\n      somewhat spotty. The satellite era of storm tracking only\n      began in 1965, so it is completely possible that there were major storms that stayed at sea that no\n      one was aware of.\n    ")]),_vm._v(" "),_c('p',{staticClass:"col-sm-10 offset-sm-1 col-lg-10 offset-lg-1"},[_vm._v("\n      Storms typically develop in warm water near the equator. They're most common in the first half\n      of the year in the southern hemisphere, with storm likelihood switching to the\n      northern hemisphere in the second half of the year. It's unclear if there will be\n      more storms as the climate warms, but the storms that do form will, likely, be more\n      intense than they otherwise would have been.\n    ")]),_vm._v(" "),_c('p',{staticClass:"col-sm-10 offset-sm-1 col-lg-10 offset-lg-1"},[_vm._v("\n      The map below shows every named storm since 1995. If you don't want to wait for the animation\n      you can drag the slider to any point on the time line. Pause the animation and hover\n      over any storm circle to see the storm intensity at that on the time line.\n      Zoom and pan the map for a closer look.\n    ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"col-sm-10 offset-sm-1 col-lg-10 offset-lg-1"},[_vm._v("\n      Where are the big, recent storms: Harvey, Irma and Maria? They're not included in the data provided by\n      the National Oceanic and Atmospheric Administration. They'll be added in when data becomes available.\n    ")]),_vm._v(" "),_c('p',{staticClass:"col-sm-10 offset-sm-1 col-lg-10 offset-lg-1"},[_vm._v("\n      Note: Maximum sustained winds are calculated differently depending on where the storm occurs. In the\n      Atlantic and Northeastern Pacific, wind speeds are the maximum sustained wind speed for one\n      minute. In the rest of the world, wind intensity is the maximum sustained wind speed over either\n      a three-minute or, more commonly, ten minute period. This can make it seem that storms that are actually of the same intensity are\n      more intense in the Atlantic and Northeastern Pacific. Unfortunately there's no real way to correct for\n      this in the available data.\n    ")]),_vm._v(" "),_c('timer',{attrs:{"dateValues":_vm.dates}}),_vm._v(" "),_c('circle-legend',{attrs:{"dataValues":_vm.hurricanes,"field":_vm.selector}}),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col-lg-2"},[_c('scroller')],1),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-lg-10",attrs:{"id":"base"}},[_c('svg',{attrs:{"id":"map","width":_vm.width,"height":"575px"}},[_c('g',[_c('rect',{attrs:{"height":_vm.height,"width":_vm.width}}),_vm._v(" "),_vm._l((_vm.selectedHurricanes),function(d,index){return [_c('circle',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.html",modifiers:{"html":true}}],attrs:{"id":d.name + index,"cx":_vm.projection([+d.lng, +d.lat])[0],"cy":_vm.projection([+d.lng, +d.lat])[1],"r":_vm.scale(+d.wind),"title":_vm.hurricaneNote(d),"variant":"outline-success"}})]})],2)])]),_vm._v(" "),_c('canvas-map')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"col-sm-10 offset-sm-1 col-lg-10 offset-lg-1"},[_vm._v("\n      If you'd like to make a donation to help the victims of the recent spate of huge hurricanes to strike\n      the United States and Caribbean:\n      "),_c('ul',[_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://www.nytimes.com/2017/09/22/world/americas/hurricane-maria-donate-charity.html"}},[_vm._v("Hurricane Maria")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://www.nytimes.com/2017/09/08/us/hurricane-irma-help-donate.html"}},[_vm._v("Hurricane Irma")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://www.nytimes.com/2017/08/28/us/donate-harvey-charities-scams.html"}},[_vm._v("Hurricane Harvey")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wXSp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-legend",class:{'circle-legend': _vm.centerClass}},[_c('h4',{style:({ marginLeft: _vm.offSet})},[_vm._v(" Wind Speed (Miles per Hour)")]),_vm._v(" "),_c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('g',{attrs:{"id":_vm.field,"width":_vm.width,"transform":"translate(20,15)"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xmL5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zVxl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__("vwbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CircleLegend__ = __webpack_require__("17cw");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var ktToMph = 1.1152,
    ktToKm = 1.85;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CanvasMap',

  data: function data() {
    return {
      width: 250,
      height: 300,
      selector: 'canvas',
      hurricanes: [],
      names: [{ name: "TIP", wind: 140, mph: this.roundUp(140 * ktToMph), date: '1979',
        km: this.roundUp(140 * ktToKm), center: [140, 15], cost: 'Most intense storm in the Pacific' }, { name: "PATRICIA", wind: 185, mph: this.roundUp(185 * ktToMph), date: '2015',
        km: this.roundUp(185 * ktToKm), center: [-80, 30], cost: 'Most intense storm in the Americas' }, { name: "FANTALA", wind: 135, mph: this.roundUp(135 * ktToMph), date: '2016',
        km: this.roundUp(135 * ktToKm), center: [85, 20], cost: 'Most intense storm in the Indian Ocean' }, { name: "KATRINA", wind: 150, mph: this.roundUp(150 * ktToMph), date: '2005',
        km: this.roundUp(150 * ktToKm), center: [-80, 30], cost: 'Cost: 108 billion USD' }, { name: "SANDY", wind: 100, mph: this.roundUp(100 * ktToMph), date: '2012',
        km: this.roundUp(100 * ktToKm), center: [-80, 30], cost: 'Cost: 75 billion USD' }, { name: "ANDREW", wind: 150, mph: this.roundUp(150 * ktToMph), date: '1992',
        km: this.roundUp(150 * ktToKm), center: [-80, 30], cost: 'Cost: 26.5 billion USD' }]
    };
  },


  components: {
    CircleLegend: __WEBPACK_IMPORTED_MODULE_2__CircleLegend__["a" /* default */]
  },

  methods: {
    roundUp: function roundUp(val) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash__["round"](val, 1);
    },
    mapScale: function mapScale(data) {
      return __WEBPACK_IMPORTED_MODULE_0_d3__["a" /* scaleSqrt */]().domain(__WEBPACK_IMPORTED_MODULE_0_d3__["b" /* extent */](data, function (d) {
        return +d.wind;
      })).range([.5, 6]);
    },
    formatValues: function formatValues(data) {
      var ktToMph = 1.1152;
      var ktToKm = 1.85;
      var windFormat = __WEBPACK_IMPORTED_MODULE_0_d3__["c" /* format */](".1f");

      data.forEach(function (d) {
        d.mph = windFormat(d.wind * ktToMph);
        d.km = windFormat(d.wind * ktToKm);
      });

      return data;
    },
    draw: function draw() {
      var vm = this;

      __WEBPACK_IMPORTED_MODULE_0_d3__["g" /* queue */]().defer(__WEBPACK_IMPORTED_MODULE_0_d3__["h" /* json */], 'static/data/map.geojson').defer(__WEBPACK_IMPORTED_MODULE_0_d3__["i" /* csv */], 'static/data/big_storms.csv').await(function (error, map, data) {
        vm.hurricanes = vm.formatValues(data);
        var storms = __WEBPACK_IMPORTED_MODULE_1_lodash__["groupBy"](data, 'name');
        var sizing = vm.mapScale(data);

        var scale = 1,
            mapType = __WEBPACK_IMPORTED_MODULE_0_d3__["j" /* geoEquirectangular */](),
            projection = mapType.scale(scale).translate([0, 0]);

        var path = __WEBPACK_IMPORTED_MODULE_0_d3__["k" /* geoPath */]().projection(projection);
        var bounds = path.bounds(map);
        scale = .98 / Math.max((bounds[1][0] - bounds[0][0]) / vm.width * .3, (bounds[1][1] - bounds[0][1]) / vm.height * .25);
        var translation = [(vm.width - scale * (bounds[1][0] + bounds[0][0])) / 2, (vm.height - scale * (bounds[1][1] + bounds[0][1])) / 2];

        // update projection
        projection = mapType.scale(scale).translate(translation);

        for (var i = 0, n = vm.names.length; i < n; ++i) {
          var canvas = __WEBPACK_IMPORTED_MODULE_0_d3__["f" /* select */]('#' + vm.names[i].name);
          var ctx = canvas.node().getContext('2d');

          projection.center(vm.names[i].center);
          path = __WEBPACK_IMPORTED_MODULE_0_d3__["k" /* geoPath */]().projection(projection).context(ctx);

          ctx.beginPath();
          path({ type: 'FeatureCollection', features: map.features });

          ctx.fillStyle = 'rgba(255, 255, 255, 0.25)';
          ctx.fill();
          ctx.lineWidth = 1;
          ctx.strokeStyle = 'rgba(255, 255, 255, 0.2)';
          ctx.stroke();

          // Add hurricane path
          for (var t = 0, r = storms[vm.names[i].name].length; t < r; ++t) {
            var node = storms[vm.names[i].name][t];
            node.x = projection([node.lng, node.lat])[0];
            node.y = projection([node.lng, node.lat])[1];

            ctx.beginPath();
            ctx.moveTo(node.x, node.y);
            ctx.arc(node.x, node.y, sizing(node.wind), 0, 2 * Math.PI, false);
            ctx.lineWidth = 4;
            ctx.fillStyle = 'rgba(178,34,34,0.5)';
            ctx.fill();
          }
        }
      });
    }
  },

  mounted: function mounted() {
    this.draw();
  }
});

/***/ }),

/***/ "zfDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scroller_vue__ = __webpack_require__("FNkW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_176bf7ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Scroller_vue__ = __webpack_require__("GaJf");
function injectStyle (ssrContext) {
  __webpack_require__("0GND")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-176bf7ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scroller_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_176bf7ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Scroller_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.9b7919644a63965651f8.js